import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getProductFilters } from "../../store/product";

import BlockLoader from "../blocks/BlockLoader";
import { frontUrl } from "../../common";
import { toast } from "react-toastify";


const AdvanceSearch = ({ categorylist, getProductFilters, filters }) => {
    const getSize = (event) => {
        console.log("clicking on size here", event.target.value);
        getProductFilters(event.target.value);
    };
    let sizes = [];
    console.log("data coming here to check ", filters);
   const [searchval, setSearchVal] = useState({ slug: "", size: "" });
    if (filters.items.length > 0) {
        var index = filters.items.findIndex((s) => s.code === "size");
        if (filters.items.hasOwnProperty(index)) {
            sizes = filters.items[index].options;
        }
    }
  
  const onChangeSelect = (element) => {
    setSearchVal({ ...searchval, ...{ [element.target.name]: element.target.value } });


  }

  const searchSubmit = (element) => {

    console.log("search val data coming here", searchval);
    if (searchval.cat_slug == '')
    {
      toast.error('Please select Product Type');
      return false
    }

    
    if (searchval.size == "") {
        toast.error("Please select Tyre Size");
        return false;
    }
        window.location.href=frontUrl+'/shop/catalog/'+searchval.slug+'?size='+searchval.size

  }
    return (
        <form>
            <fieldset class="search_fieldset">
                <legend>QUICK FIND YOUR TYRES</legend>
            </fieldset>

            <div class="form-row">
                <div class="col-md-5 mb-2">
                    <div class="input-group input-group-lg">
                        <select
                            class="custom-select"
                            id="inputGroupSelect01"
                            onChange={(e) => {
                                getSize(e);
                                onChangeSelect(e);
                            }}
                            placeholder="Choose..."
                            name="slug"
                        >
                            <option>Select Tyre Category...</option>
                            {categorylist.items.reverse().map((values) => {
                                if (values.slug == "root" || values.slug == "motor" || values.slug == "bicycle" || values.slug == "tube" || values.slug == "e-bike") {
                                    return false;
                                }
                                return <option value={values.slug} selected={searchval.slug===values.slug?(true):('')}>{values.name}</option>;
                            })}
                        </select>
                    </div>
                </div>
                <div class="col-md-5 mb-2">
                    <div class="input-group input-group-lg">
                        <select class="custom-select" id="inputGroupSelect02" name="size" onChange={onChangeSelect}>
                            {filters.loading ? (
                                <option value="">Loading...</option>
                            ) : (
                                <option value="">Select Size... </option>
                            )}
                            {sizes.map((values) => {
                                if (!filters.productspecific.includes(String(values.id))) {
                                    return false;
                                }
                                return <option value={values.id}>{values.admin_name}</option>;
                            })}
                        </select>
                    </div>
                </div>
                <div class="col-md-2">
                    <button type="button" onClick={searchSubmit} class="btn btn-primary chk_btn">
                        Search Now
                    </button>
                </div>
            </div>
        </form>
    );
};

AdvanceSearch.propTypes = {};

AdvanceSearch.defaultProps = {};
const mapStateToProps = (state) => {
    console.log("state banner", state);
    return {
        categorylist: state.categories,
        filters: state.productfilter,
    };
};

const mapDispatchToProps = {
    getProductFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvanceSearch);
